export const overallPlaytimeFormatter = (params: any, res: any) => {
  const { page, page_size, row_count, average = {} } = res || {}
  const pageCount = params?.page_size * page
  const isLast = pageCount >= row_count && row_count
  if (isLast) {
    res.aggregation = [{ ...average, date: '', type: 'avg' }]
  }
  return res
}
